import { CATNAV_PAGINATION_CHANGE_SPEED_EXPERIMENT_240604 } from "@faire/web-api/indigofair/settings/CATNAV_PAGINATION_CHANGE_SPEED_EXPERIMENT_240604";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingCatNavPaginationChangeSpeedExperiment = (): boolean =>
  getSettingValueWithoutAssignment(
    CATNAV_PAGINATION_CHANGE_SPEED_EXPERIMENT_240604,
    false
  );

export const assignCatNavPaginationChangeSpeedExperiment = () => {
  assignSetting(CATNAV_PAGINATION_CHANGE_SPEED_EXPERIMENT_240604);
};
